import {trackPageNavigation} from './events/navigation'
import measureWebVitals from './events/performance'

measureWebVitals()
trackPageNavigation()
